export const environment = {
  production: false,
  environment: 'staging', // 'dev', 'staging', or 'production'
  version: '2026-02-06-1056', // Update this string after every major deploy
  restrictToDevOrGod: true,
  useYearBasedCollections: true, // Enable year-based portal-data collections
  firebase: {
    apiKey: 'AIzaSyDZYKFPqiLqkuJmu6xzoiCdkyOEE8Vn0ng',
    authDomain: 'cb-ops-stage.firebaseapp.com',
    projectId: 'cb-ops-stage',
    storageBucket: 'cb-ops-stage.firebasestorage.app',
    messagingSenderId: '345635575373',
    appId: '1:345635575373:web:d4825906611a11a9b8ae0',
    databaseURL: 'https://cb-ops-stage-default-rtdb.firebaseio.com',
  },
  // Staging uses its own database instances (separate from dev and prod)
  clickupDatabaseURL:
    'https://cb-ops-stage-clickup-data-default-rtdb.firebaseio.com',
  quickbooksDatabaseURL:
    'https://cb-ops-stage-quickbooks-data-default-rtdb.firebaseio.com',
  harvestDatabaseURL:
    'https://cb-ops-stage-harvest-data-default-rtdb.firebaseio.com',
  // URL for backend functions (staging endpoint) - Cloud Run URL for 2nd gen functions
  functionsUrl: 'https://api-bt7kmxpc6a-uc.a.run.app',
};
